import styled from "styled-components/macro";

export const TopBarContainer = styled.div`
  display: flex;
  top: 0%;
  left: 0%;
  background: var(--clr-darkgray);

  justify-content: space-between;
  align-items: flex-end;
  height: 7%;
  /* font-size: 1.1rem; */
  font-size: .9rem;
  grid-area: topbar;
  /* padding: 0.5em; */
`;

export const TopBarIconContainer = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  gap: 0.25em;
`;

export const TopBarTime = styled.div`
  display: inline;
`;

export const TopBarIconWrapper = styled.div`
color: #caceca;
margin-top: .2em;
margin-left: 0.35em;
font-size: .9rem;
`;

export const TopBarBattery = styled.img`
  /* max-height: 23px; */
  height: 18px;
  width: auto;
  /* margin-left: 0.1em; */
`;

export const TopBarIconPng = styled.img`
  height: 15px;
  width: auto;
  margin-left: 0.35em;
  /* margin-top: .06em; */
  /* margin-bottom: .1em; */
`;

export const TopBarMonitor = styled.img`
  /* height: 19px; */
  height: 15px;

  width: auto;
`;
